import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthProvider';
import { useScreen } from '../lib/useScreen';
import { supabase } from '../lib/supabaseClient';
import SidebarEscritorio from '../components/sala/SidebarEscritorio';
import ProjectCard from '../components/sala/ProjectCard';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = { turquesa:'#5dc1b9', mango:'#FDBE02', morado:'#534AB7', moradoClaro:'#AFA9EC' };

export default function ProyectosPage() {
  const { user, profile, membership } = useAuth();
  const { isMobile, w } = useScreen();
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [proyectos, setProyectos] = useState([]);
  const [ciudades, setCiudades] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const cargar = async () => {
      const { data: profs } = await supabase
        .from('profiles')
        .select('id, full_name, business_name, business_type, business_stage, avatar_url, foto_proyecto, presentacion_descripcion, presentacion_quien, presentacion_que_busca, country_id, region_id, city_id, city')
        .eq('onboarding_done', true);
      setProyectos(profs || []);

      // Resolve cities in batch
      const cityIds = (profs || []).map(p => p.city_id).filter(Boolean);
      const countryIds = (profs || []).map(p => p.country_id).filter(Boolean);
      const uniqueCityIds = [...new Set(cityIds)];
      const uniqueCountryIds = [...new Set(countryIds)];

      const ciudadMap = {};

      if (uniqueCityIds.length > 0) {
        const { data: cities } = await supabase.from('cities').select('id, name').in('id', uniqueCityIds);
        (cities || []).forEach(c => { ciudadMap[`city_${c.id}`] = c.name; });
      }
      if (uniqueCountryIds.length > 0) {
        const { data: countries } = await supabase.from('countries').select('id, name').in('id', uniqueCountryIds);
        (countries || []).forEach(c => { ciudadMap[`country_${c.id}`] = c.name; });
      }

      // Build city strings per profile
      const resolvedCities = {};
      (profs || []).forEach(p => {
        const parts = [];
        if (p.city_id && ciudadMap[`city_${p.city_id}`]) parts.push(ciudadMap[`city_${p.city_id}`]);
        if (p.country_id && ciudadMap[`country_${p.country_id}`]) parts.push(ciudadMap[`country_${p.country_id}`]);
        if (parts.length === 0 && p.city) parts.push(p.city);
        resolvedCities[p.id] = parts.join(', ');
      });
      setCiudades(resolvedCities);
      setLoading(false);
    };
    cargar();
  }, []);

  return (
    <div style={{ background:'#0a0a0a', minHeight:'100vh', fontFamily:font, color:'#fff' }}>
      {/* Header */}
      <header style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'11px 16px', borderBottom:'0.5px solid rgba(255,255,255,0.06)' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          {isMobile && <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background:'none', border:'none', color:'#fff', fontSize:18, cursor:'pointer' }}>☰</button>}
          <span style={{ fontFamily:serif, fontSize:17, background:'linear-gradient(90deg, #5dc1b9, #FDBE02, #eb636b)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text' }}>T&D</span>
          <span style={{ fontSize:11, padding:'2px 8px', borderRadius:999, background:'rgba(83,74,183,0.18)', color:C.moradoClaro }}>Proyectos</span>
        </div>
        <div style={{ width:28, height:28, borderRadius:'50%', background:'linear-gradient(135deg, #534AB7, #1D9E75)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:600 }}>
          {(profile?.full_name || 'U')[0]}
        </div>
      </header>

      <div style={{ display:'flex', minHeight:'calc(100vh - 50px)' }}>
        {/* Sidebar */}
        {w >= 900 && (sidebarOpen || !isMobile) && (
          <SidebarEscritorio membership={membership} currentView="conoce" />
        )}

        {/* Main */}
        <main style={{ flex:1, padding:isMobile?'16px 12px':'20px 24px', overflowY:'auto' }}>
          <div style={{ marginBottom:24 }}>
            <p style={{ fontSize:10, color:'rgba(93,193,185,0.8)', letterSpacing:1.5, textTransform:'uppercase', margin:'0 0 4px' }}>Red de emprendedores</p>
            <h1 style={{ fontFamily:serif, fontSize:22, fontWeight:400, margin:'0 0 6px' }}>Conoce proyectos</h1>
            <p style={{ margin:0, fontSize:14, color:'rgba(255,255,255,0.55)', lineHeight:1.6 }}>Todos los emprendedores de la comunidad T&D</p>
          </div>

          {loading ? (
            <div style={{ textAlign:'center', padding:'4rem 0' }}>
              <div style={{ width:24, height:24, border:'3px solid rgba(255,255,255,0.08)', borderTopColor:'#5dc1b9', borderRadius:'50%', animation:'tdSpin 0.8s linear infinite', margin:'0 auto 10px' }} />
              <p style={{ fontSize:14, color:'rgba(255,255,255,0.4)' }}>Creando tu experiencia...</p>
              <style>{`@keyframes tdSpin { to { transform: rotate(360deg); } }`}</style>
            </div>
          ) : proyectos.length === 0 ? (
            <div style={{ textAlign:'center', padding:'4rem 0' }}>
              <p style={{ fontSize:32, margin:'0 0 12px' }}>🔭</p>
              <p style={{ fontSize:14, color:'rgba(255,255,255,0.5)' }}>Aún no hay proyectos publicados.</p>
            </div>
          ) : (
            <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap:20 }}>
              {proyectos.map(p => (
                <ProjectCard
                  key={p.id}
                  perfil={p}
                  ciudad={ciudades[p.id] || ''}
                  onVerPerfil={(uid) => navigate('/proyecto/' + uid)}
                  isMobile={isMobile}
                />
              ))}
            </div>
          )}
        </main>
      </div>

    </div>
  );
}
